var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base mb-5" }, [
              _vm._v("Edit personal information"),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-5",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              { staticClass: "relative" },
              [
                _c(
                  "LoadingOverlay",
                  { attrs: { loading: _vm.loading, hasData: true } },
                  [
                    _vm.managementAddedInfoMode.email
                      ? _c("div", { attrs: { id: "contactinfoslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "Email Address",
                                  rules: "email",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            staticClass: "mt-6",
                                            attrs: {
                                              name: "email",
                                              title: "",
                                              type: "search",
                                              placeholder: "Enter email",
                                              errors: errors,
                                              inputClass: "fullwidthInput",
                                              isIcon: false,
                                            },
                                            on: {
                                              hasErrors: (hasErrors) => {
                                                _vm.emailHasErrors = hasErrors
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(
                                                            "Email Address "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "action",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.email,
                                                          },
                                                          on: {
                                                            click: () => {
                                                              _vm.removeEmails()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("DeleteGray", {
                                                            staticClass:
                                                              "w-4 h-4",
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.email,
                                              callback: function ($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  417690576
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-end mt-2 pt-3 gap-4",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Cancel",
                                      size: "lg",
                                      variant: "outline",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.closeModal },
                                  }),
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Save",
                                      size: "lg",
                                      variant: "black",
                                      processing: _vm.processing,
                                      disabled:
                                        !_vm.email || _vm.emailHasErrors,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.upsertProfileByManagement()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.phone
                      ? _c("div", { attrs: { id: "contactinfoslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "Phone number",
                                  rules: {
                                    phoneNumberLength: [10],
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row gap-2 items-center",
                                            },
                                            [
                                              _c(
                                                "FormGroup",
                                                {
                                                  staticClass: "flex-1",
                                                  attrs: {
                                                    title: "",
                                                    type: "search",
                                                    errors: _vm.phoneTouched
                                                      ? errors
                                                      : [],
                                                    isIcon: false,
                                                    inputClass:
                                                      "fullwidthInput",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "title",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "required-icon",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "Phone number "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: _vm.phone,
                                                    callback: function ($$v) {
                                                      _vm.phone = $$v
                                                    },
                                                    expression: "phone",
                                                  },
                                                },
                                                [
                                                  _c("MaskedPhoneInput", {
                                                    attrs: {
                                                      invalid: Boolean(
                                                        _vm.phoneTouched &&
                                                          errors.length
                                                      ),
                                                    },
                                                    on: {
                                                      touched: () => {
                                                        _vm.phoneHasErrors =
                                                          !!errors.length
                                                        _vm.phoneTouched = true
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.phone,
                                                      callback: function ($$v) {
                                                        _vm.phone = $$v
                                                      },
                                                      expression: "phone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  attrs: {
                                                    disabled: !_vm.phone,
                                                  },
                                                  on: {
                                                    click: () => {
                                                      _vm.removePhoneNumbers()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("DeleteGray", {
                                                    staticClass: "w-4 h-4 mt-6",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2116230095
                                ),
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-end mt-2 pt-3 gap-4",
                                },
                                [
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Cancel",
                                      size: "lg",
                                      variant: "outline",
                                      processing: _vm.processing,
                                    },
                                    on: { click: _vm.closeModal },
                                  }),
                                  _c("UIButton", {
                                    attrs: {
                                      buttonText: "Save",
                                      size: "lg",
                                      variant: "black",
                                      processing: _vm.processing,
                                      disabled:
                                        !_vm.phone || _vm.phoneHasErrors,
                                    },
                                    on: {
                                      click: () => {
                                        _vm.upsertProfileByManagement()
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.website
                      ? _c("div", { attrs: { id: "websiteslot" } }, [
                          _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "url" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("FormGroup", {
                                            staticClass: "mt-6",
                                            attrs: {
                                              name: "website",
                                              title: "",
                                              type: "search",
                                              placeholder: "URL here",
                                              errors: errors,
                                              inputClass: "fullwidthInput",
                                              isIcon: false,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "title",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "p",
                                                        { staticClass: "mb-2" },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(
                                                            "Website URL "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "action",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              !_vm.website,
                                                          },
                                                          on: {
                                                            click: () => {
                                                              _vm.removeWebsites()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("DeleteGray", {
                                                            staticClass:
                                                              "w-4 h-4",
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.website,
                                              callback: function ($$v) {
                                                _vm.website = $$v
                                              },
                                              expression: "website",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex justify-end mt-2 pt-3 gap-4",
                                            },
                                            [
                                              _c("UIButton", {
                                                attrs: {
                                                  buttonText: "Cancel",
                                                  size: "lg",
                                                  variant: "outline",
                                                  processing: _vm.processing,
                                                },
                                                on: { click: _vm.closeModal },
                                              }),
                                              _c("UIButton", {
                                                attrs: {
                                                  buttonText: "Save",
                                                  size: "lg",
                                                  variant: "black",
                                                  processing: _vm.processing,
                                                  disabled:
                                                    !_vm.website ||
                                                    !!errors.length,
                                                },
                                                on: {
                                                  click: () => {
                                                    _vm.upsertProfileByManagement()
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2838632485
                                ),
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.country ||
                    _vm.managementAddedInfoMode.region ||
                    _vm.managementAddedInfoMode.city
                      ? _c(
                          "div",
                          [
                            _c("ValidationObserver", [
                              _c(
                                "form",
                                { staticClass: "mt-5" },
                                [
                                  _c("FormGroup", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      name: "address",
                                      isIcon: false,
                                      type: "search",
                                      title: "Address",
                                      placeholder: "Enter address",
                                      iconStyle: "customIcon",
                                      inputClass: "fullwidthInput",
                                    },
                                    model: {
                                      value: _vm.address,
                                      callback: function ($$v) {
                                        _vm.address = $$v
                                      },
                                      expression: "address",
                                    },
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "Country",
                                      rules: "required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "FormGroup",
                                                {
                                                  attrs: {
                                                    title: "",
                                                    errors: errors,
                                                    isIcon: false,
                                                    inputClass:
                                                      "fullwidthInput",
                                                  },
                                                  on: {
                                                    hasErrors: (hasErrors) => {
                                                      _vm.countryHasErrors =
                                                        hasErrors
                                                    },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "title",
                                                        fn: function () {
                                                          return [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "required-icon",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "Country "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("ProfileCountrySelect", {
                                                    attrs: {
                                                      getcontainerStyle:
                                                        "fullWidthInput",
                                                    },
                                                    model: {
                                                      value: _vm.country,
                                                      callback: function ($$v) {
                                                        _vm.country = $$v
                                                      },
                                                      expression: "country",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      333827897
                                    ),
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: { name: "State" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("RegionInput", {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  countries: _vm.country,
                                                  errors: errors,
                                                  iconStyle: "customIcon",
                                                  title: "Region",
                                                  isIcon: false,
                                                  shouldFullWidth:
                                                    "customFullWidthInput",
                                                  getcontainerStyle:
                                                    "customFullWidthInput",
                                                },
                                                model: {
                                                  value: _vm.state,
                                                  callback: function ($$v) {
                                                    _vm.state = $$v
                                                  },
                                                  expression: "state",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1801034801
                                    ),
                                  }),
                                  _c("FormGroup", {
                                    staticClass: "flex-1 mt-2",
                                    attrs: {
                                      name: "postal_code",
                                      isIcon: false,
                                      type: "search",
                                      title: "Postal / Zip Code",
                                      placeholder: "Enter postal / zip code",
                                      iconStyle: "customIcon",
                                      inputClass: "fullwidthInput",
                                    },
                                    model: {
                                      value: _vm.postal_code,
                                      callback: function ($$v) {
                                        _vm.postal_code = $$v
                                      },
                                      expression: "postal_code",
                                    },
                                  }),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "City",
                                      rules: "name_with_specific_symbols",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  title: "City",
                                                  type: "search",
                                                  placeholder: "Enter city",
                                                  iconStyle: "customIcon",
                                                  inputClass: "fullwidthInput",
                                                  errors: errors,
                                                  isIcon: false,
                                                },
                                                on: {
                                                  hasErrors: (hasErrors) => {
                                                    _vm.cityHasErrors =
                                                      hasErrors
                                                  },
                                                },
                                                model: {
                                                  value: _vm.city,
                                                  callback: function ($$v) {
                                                    _vm.city =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "city",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      988999546
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex justify-end mt-2 pt-3 space-x-4",
                              },
                              [
                                _vm.profileLocation
                                  ? _c("UIButton", {
                                      attrs: {
                                        size: "lg",
                                        variant: "outline",
                                        buttonText: "Delete",
                                        processing: _vm.deleting,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.removeLocation()
                                        },
                                      },
                                    })
                                  : _c("UIButton", {
                                      attrs: {
                                        size: "lg",
                                        variant: "outline",
                                        buttonText: "Cancel",
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                _c("UIButton", {
                                  attrs: {
                                    buttonText: "Save",
                                    size: "lg",
                                    variant: "black",
                                    processing: _vm.processing,
                                    disabled:
                                      !_vm.country.length ||
                                      (!_vm.state &&
                                        !_vm.postal_code &&
                                        !_vm.city) ||
                                      _vm.countryHasErrors ||
                                      _vm.cityHasErrors,
                                  },
                                  on: {
                                    click: () => {
                                      _vm.upsertProfileByManagement()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.resume
                      ? _c("div", [_vm._v("Resume")])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [_c("p", [_vm._v("Buttons")])]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }